import React from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { useEffect } from "react";
import Spinner from "../../../component/loadingbar/Spinner";

const AddSalesType = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();

  //--------------------------------- manage state ---------------------------------
  const [loading, setLoading] = useState(false);
  const [parents, setParents] = useState([]);
  const [selectedParent, setSelectedParent] = useState("");
  const [empType, setEmpType] = useState("");
  const [incentive, setIncentive] = useState("");

  //state change handler function
  const handleEmpTypeChange = (e) => {
    setEmpType(e.target.value);
  };
  const handleParentChangeDropdown = (e) => {
    setSelectedParent(e.target.value);
  };
  const handleIncentiveChange = (e) => {
    setIncentive(e.target.value);
  };

  //---------------------------------- get parent for dropdown option --------------------r
  useEffect(() => {
    setLoading(true);
    // Fetch course list
    fetch(`${config.host_url}sales-type`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setParents(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  // ---------------------------------------------- create / update / edit class ----------------------------------------------------u--c
  const createSalesTypeBtn = async () => {
    if (!empType.trim() || !selectedParent || incentive === "") {
      triggerNotification("error", "Input fields cannot be empty!!");
      return;
    }
    try {
      await fetch(
        `${config.host_url}sales-type/${
          id ? decodeURIComponent(atob(id)) : ""
        }`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            sales_emp_type: empType,
            parent_type: selectedParent,
            incentive: incentive,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `Sales employee type ${id ? "updated" : "created"} successfully.`
            );
            setEmpType("");
            setIncentive("");
            setSelectedParent("");
            navigate("/viewsalestype");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error(`Error ${id ? "updated" : "created"} sales type:`, error);
      triggerNotification(
        "error",
        `An error occurred while ${id ? "updated" : "created"} the sales type.`
      );
    }
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setEmpType("");
    setSelectedParent("");
    setIncentive("");

    if (id) {
      navigate("/viewsalestype");
    }
  };

  //---------------------------------------------- get data for update / edit Sales employee type ----------------------------------------------------r
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}sales-type/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const responseData = data.data;
          setSelectedParent(responseData.parent_type);
          setEmpType(responseData.sales_emp_type);
          setIncentive(responseData.incentive);
          console.log(data.data);
          setLoading(false);
        });
    }
  }, [id]);
  return (
    <>
      <Breadcrumb txt="Manage Sales Type" subpath={["Add Sales Type"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Sales Type</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              {/* <p>{empType}</p> */}
              <form>
                {/* Sales Employee Type */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="semptyp"
                    id="semptyp"
                    placeholder="Sales Employee Type"
                    value={empType}
                    onChange={handleEmpTypeChange}
                    autoComplete="off"
                  />
                  <label htmlFor="semptyp"> Sales Employee Type</label>
                </div>
                {/* Parent Type */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select mx-auto"
                      id="classdropdown"
                      value={selectedParent}
                      onChange={handleParentChangeDropdown}
                    >
                      <option
                        value=""
                        disabled
                        selected
                        className="text-center"
                      >
                        ---- Select Parent Type ----
                      </option>
                      {parents.map((parent) => (
                        <option key={parent.tid} value={parent.tid}>
                          {parent.sales_emp_type}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="classdropdown">Parent Type</label>
                  </div>
                </div>
                {/* Incentive  */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="number"
                    className="form-control"
                    name="incentive"
                    id="incentive"
                    placeholder="Incentive "
                    value={incentive}
                    onChange={handleIncentiveChange}
                  />
                  <label htmlFor="incentive"> Incentive </label>
                </div>
                {/* submit | cancel */}
                <div className="mt-3 flex justify-content-end">
                  <div className="">
                    {/* clear/ calcel */}
                    <button
                      type="button"
                      className="btn  btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                    {/* submit */}
                    <button
                      type="button"
                      className="btn ml-2 btn-primary"
                      onClick={createSalesTypeBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddSalesType;
